"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dump = void 0;
var getCircularReplacer = function () {
    var seen = new WeakSet();
    return function (key, value) {
        if (typeof value === "object" && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};
function dump(obj) {
    return JSON.stringify(obj, getCircularReplacer(), 4);
}
exports.dump = dump;
//# sourceMappingURL=debug.js.map